import {UpdateType} from './types';

export const hasWebUpdates = (type: UpdateType | undefined) => {
    return type === UpdateType.Web || type === UpdateType.WebAndDesktop;
};

export const hasDesktopUpdates = (type: UpdateType | undefined) => {
    return type === UpdateType.Desktop || type === UpdateType.WebAndDesktop;
};
